import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "chat" }
const _hoisted_2 = { class: "chat-part" }
const _hoisted_3 = {
  key: 0,
  class: "chat-loading"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ChatHeader = _resolveComponent("ChatHeader")
  const _component_Loader = _resolveComponent("Loader")
  const _component_AIChat = _resolveComponent("AIChat")
  const _component_ChatComposer = _resolveComponent("ChatComposer")
  const _component_ShareModalV2 = _resolveComponent("ShareModalV2")
  const _component_AddPrompt = _resolveComponent("AddPrompt")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ChatHeader, {
        shared: $options.shared,
        "can-share": $options.can_share,
        generating: $options.generating,
        onShare: $options.share
      }, null, 8 /* PROPS */, ["shared", "can-share", "generating", "onShare"]),
      ($options.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_Loader, null, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode(" Loading chat data"),
                _createElementVNode("br", null, null, -1 /* HOISTED */),
                _createTextVNode(" Please wait... ")
              ])),
              _: 1 /* STABLE */
            })
          ]))
        : _createCommentVNode("v-if", true),
      (!$options.loading)
        ? (_openBlock(), _createBlock(_component_AIChat, {
            key: 1,
            ref: "chat",
            class: "chat-container",
            "chat-id": $props.chat.id,
            history: $props.chat.history,
            generating: $options.generating,
            readonly: $options.readonly,
            "ref-history-len": $options.ref_history_len,
            mode: "expanded",
            onAskAi: $options.onChat,
            onRefrag: _cache[0] || (_cache[0] = ({idx, range}) => $options.onRegenerateFragment(idx, range)),
            onPromptSave: _cache[1] || (_cache[1] = ({idx}) => $options.onPromptSave(idx)),
            onLike: _cache[2] || (_cache[2] = ({idx, feedback}) => _ctx.$debounce_200($options.onLike, idx, feedback)),
            onDislike: _cache[3] || (_cache[3] = ({idx, feedback}) => _ctx.$debounce_200($options.onDislike, idx, feedback)),
            onSave: _cache[4] || (_cache[4] = ({idx, text}) => _ctx.$debounce_400($options.onSave, idx, text)),
            onMeetingSave: _cache[5] || (_cache[5] = ({idx}) => _ctx.$debounce_400($options.saveMeeting, idx)),
            onPodcastSave: _cache[6] || (_cache[6] = ({idx}) => _ctx.$debounce_400($options.savePodcast, idx))
          }, null, 8 /* PROPS */, ["chat-id", "history", "generating", "readonly", "ref-history-len", "onAskAi"]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_ChatComposer, {
        ref: "input",
        "chat-id": $props.chat.id,
        history: $props.chat.history,
        generating: $options.generating,
        loading: $options.loading,
        readonly: $options.readonly,
        onResize: _cache[7] || (_cache[7] = $event => (_ctx.$nextTick(() => _ctx.$refs.chat?.setClientHeight()))),
        onRegenerate: $options.onChat,
        onStop: $options.onStop
      }, null, 8 /* PROPS */, ["chat-id", "history", "generating", "loading", "readonly", "onRegenerate", "onStop"]),
      ($options.can_share)
        ? (_openBlock(), _createBlock(_component_ShareModalV2, {
            key: 2,
            ref: "share",
            chat: $props.chat
          }, null, 8 /* PROPS */, ["chat"]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_AddPrompt, { ref: "prompts" }, null, 512 /* NEED_PATCH */)
    ])
  ]))
}